import React from 'react';
import {SEGMENTS_COLOR} from "../../../config/defaults";

export const CISmallSegment = ({fill=SEGMENTS_COLOR}) => {
    return <svg fill="currentColor" x="0" y="0" viewBox="0, 0, 24, 24">
        <g id="admin">
            <path fill={fill} d="M14.947,3 C18.29,3 21,5.71 21,9.053 L21,14.947 C21,18.29 18.29,21 14.947,21 L9.053,21 C5.71,21 3,18.29 3,14.947 L3,9.052 C3,5.71 5.71,3 9.053,3 L14.947,3 z M16.5,6 L7.5,6 C7.086,6 6.75,6.336 6.75,6.75 L6.75,9 C6.75,9.199 6.829,9.39 6.97,9.53 L10.5,13.061 L10.5,17.25 C10.5,17.553 10.683,17.827 10.963,17.943 C11.243,18.059 11.566,17.995 11.78,17.78 L13.28,16.28 C13.421,16.14 13.5,15.949 13.5,15.75 L13.5,13.061 L17.03,9.53 C17.171,9.39 17.25,9.199 17.25,9 L17.25,6.75 C17.25,6.336 16.914,6 16.5,6 z"/>
        </g>
    </svg>;
};